export const data={
    "success": true,
    "message": "查询成功",
    "code": 200,
    "result": {
        "allAuth": [
            {
                "action": "user:form:phone",
                "describe": "手机号禁用",
                "type": "2",
                "status": "1"
            },
            {
                "action": "user:add",
                "describe": "添加用户按钮",
                "type": "1",
                "status": "1"
            }
        ],
        "auth": [
            {
                "action": "user:form:phone",
                "describe": "手机号禁用",
                "type": "2"
            }
        ],
        "menu": [
                    // {
                    //     "redirect": null,
                    //     "path": "index",
                        
                    //     "component": "home/index",
                    //     'hasChildrenShow':'0',
                    //     "meta": {
                    //         "keepAlive": "true",
                    //         "title": "首页"
                    //     },
                    // },
                    // {
                    //     "path": "user",
                    //     "component": "user/user",
                        
                    //     "meta": {
                    //         "keepAlive": "true",
                    //         "title": "角色维护"
                    //     },
                    //     "name": "system-roleUserList",
                    //     "id": "190c2b43bec6a5f7a4194a85db67d96a",
                    //     'hasChildrenShow':'1',
                    //     "children":[
                    //         {
                    //             "path": "set",
                    //             "component": "user/user",
                                
                    //             'redirect':'/set/set',
                    //             "meta": {
                    //                 "keepAlive": "true",
                    //                 "title": "角色设置"
                    //             },
                    //             'children':[
                    //                 {
                    //                     "path": "set/set",
                    //                     "component": "user/creat3",
                                        
                    //                     "meta": {
                    //                         "keepAlive": "true",
                    //                         "title": "creat11"
                    //                     },
                    //                     "name": "system-roleUserList",
                    //                     "id": "190c2b43bec6a5f7a4194a85db67d96a",
                    //                     'hidden':'0'
                    //                 },
                    //                 {
                    //                     "path": "set/get",
                    //                     "component": "user/creat4",
                                        
                    //                     "meta": {
                    //                         "keepAlive": "true",
                    //                         "title": "creat22"
                    //                     },
                    //                     "name": "system-roleUserList",
                    //                     "id": "190c2b43bec6a5f7a4194a85db67d96a",
                    //                     'hidden':'0'
                    //                 }
                    //             ],
                    //             "name": "system-roleUserList",
                    //             "id": "190c2b43bec6a5f7a4194a85db67d96a",
                    //             'hidden':'1'
                    //         },
                    //         {
                    //             "path": "get",
                    //             "component": "user/index",
                                
                    //             "meta": {
                    //                 "keepAlive": "true",
                    //                 "title": "角色获取"
                    //             },
                    //             "name": "system-roleUserList",
                    //             "id": "190c2b43bec6a5f7a4194a85db67d96a",
                    //             'hidden':'1'
                    //         }
                    //     ]
                    // },
                    // {
                    //     "path": "creat",
                    //     "component": "user/index",
                        
                    //     "meta": {
                    //         "keepAlive": "true",
                    //         "title": "角色创建",
                    //     },
                    //     "name": "system-roleUserList",
                    //     "id": "190c2b43bec6a5f7a4194a85db67d96a",
                    //     'redirect':'/creat/set',
                    //     'hasChildrenShow':'0',
                    //     "children":[
                    //         {
                    //             "path": "creat/set",
                    //             "component": "user/creat1",
                                
                    //             "meta": {
                    //                 "keepAlive": "true",
                    //                 "title": "creat11"
                    //         },
                    //         "name": "system-roleUserList",
                    //         "id": "190c2b43bec6a5f7a4194a85db67d96a",
                    //         'hidden':'0'
                    //         },
                    //         {
                    //             "path": "creat/get",
                    //             "component": "user/creat2",
                                
                    //             "meta": {
                    //                 "keepAlive": "true",
                    //                 "title": "creat22"
                    //             },
                    //             "name": "system-roleUserList",
                    //             "id": "190c2b43bec6a5f7a4194a85db67d96a",
                    //             'hidden':'0'
                    //         }
                    //     ]
                    // },
                    // 资金监管
                    //   //资金监管窗口
                    // {
                    //     "path": "lobby",
                    //     "component": "lobbyService/index",
                        
                    //     "meta": {
                    //         "keepAlive": "true",
                    //         "title": "资金监管协议书",
                    //         "componentName":'',
                    //     },
                    //     "name": "system-roleUserList",
                    //     "id": "190c2b43bec6a5f7a4194a85db67d96a",
                    //     'redirect':'/lobby/list',
                    //     'hasChildrenShow':'0',
                    //     "children":[
                    //         {
                    //             "path": "lobby/list",
                    //             "component": "lobbyService/fundSupervision",
                                
                    //             "meta": {
                    //                 "keepAlive": "true",
                    //                 "title": "资金监管协议书  /  新建协议"
                    //             },
                    //             "name": "system-roleUserList",
                    //             "id": "190c2b43bec6a5f7a4194a85db67d96a",
                    //             'hidden':'0'
                    //         }
                    //     ]
                    // },
                    //房源验真窗口 
                    // {
                    //     "path": "authenpage",
                    //     "component": "lobbyService/authenticationHouse",
                        
                    //     "meta": {
                    //         "keepAlive": "true",
                    //         "title": "房源验真",
                    //         "componentName":'',
                    //     },
                    //     "name": "system-roleUserList",
                    //     "id": "190c2b43bec6a5f7a4194a85db67d96a",
                    //     'redirect':'/authen/list',
                    //     'hasChildrenShow':'0',
                    //     "children":[
                    //         {
                    //             "path": "authen/list",
                    //             "component": "lobbyService/authenticationHouseList",
                                
                    //             "meta": {
                    //                 "keepAlive": "true",
                    //                 "title": "房源验真列表"
                    //             },
                    //             "name": "system-roleUserList",
                    //             "id": "190c2b43bec6a5f7a4194a85db67d96a",
                    //             'hidden':'1'
                    //         },
                    //         {
                    //             "path": "authen/infor",
                    //             "component": "lobbyService/authenticationHouseInfor",
                                
                    //             "meta": {
                    //                 "keepAlive": "true",
                    //                 "title": "房源验真"
                    //             },
                    //             "name": "system-roleUserList",
                    //             "id": "190c2b43bec6a5f7a4194a85db67d96a",
                    //             'hidden':'1'
                    //         }
                    //     ]
                    // },
                    // 超级管理员  
                        // 用户管理-前端用户、企业用户
                    {
                        "path": "superuser",
                        "component": "superUser/cUser",
                        "meta": {
                            "keepAlive": "true",
                            "title": "用户管理"
                        },
                        "componentName": "用户管理",
                        'hasChildrenShow':'1',
                        "children":[
                            {
                                "path": "cuser",
                                "component": "superUser/cUser",
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "前端用户管理"
                                },
                                "name": "用户管理",
                                'hidden':'0'
                            },
                            {
                                "path": "businessUser",
                                "component": "superUser/businessUser",
                                'redirect':'/businessUser/list',
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "企业管理"
                                },
                                'children':[
                                    {
                                        "path": "businessUser/list",
                                        "component": "superUser/businessUserList",
                                        
                                        "meta": {
                                            "keepAlive": "true",
                                            "title": "企业管理"
                                        },
                                        "name": "system-roleUserList",
                                        "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                        'hidden':'0'
                                    },
                                    {
                                        "path": "businessUser/creat",
                                        "component": "superUser/businessUserCreat",
                                        
                                        "meta": {
                                            "keepAlive": "true",
                                            "title": "新建企业"
                                        },
                                        "name": "system-roleUserList",
                                        'hidden':'0'
                                    }
                                ],
                                "name": "system-roleUserList",
                                'hidden':'0'
                            },
                            
                        ]
                    },
                    // 角色管理
                    {
                        "path": "role",
                        "component": "superUser/roleIndex",
                        
                        "meta": {
                            "keepAlive": "true",
                            "title": "角色管理",
                            "componentName":'',
                        },
                        "name": "",
                        "id": "190c2b43bec6a5f7a4194a85db67d96a",
                        'redirect':'/role/list',
                        'hasChildrenShow':'0',
                        "children":[
                            {
                                "path": "role/list",
                                "component": "superUser/roleList",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "角色管理"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                            {
                                "path": "role/creat",
                                "component": "superUser/roleCreat",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "角色管理 / 新建角色"
                                },
                                "name": "system-roleUserList",
                                'hidden':'0'
                            }
                        ]
                    },
                    // 房源管理
                    {
                        "path": "houseResource",
                        "component": "superUser/houseResourceIndex",
                        
                        "meta": {
                            "keepAlive": "true",
                            "title": "房源管理",
                            "componentName":'',
                        },
                        "name": "",
                        "id": "190c2b43bec6a5f7a4194a85db67d96a",
                        'redirect':'/houseResource/list',
                        'hasChildrenShow':'0',
                        "children":[
                            {
                                "path": "houseResource/list",
                                "component": "superUser/houseResourceList",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "房源管理"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                            {
                                "path": "houseResource/creat",
                                "component": "superUser/houseResourceCreat",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "房源管理"
                                },
                                "name": "system-roleUserList",
                                'hidden':'0'
                            }
                        ]
                    },
                    // 悦居经纪人
                    // //  在售房源
                    // {
                    //     "path": "salingHouse",
                    //     "component": "yjAgent/salinghouse",
                    //     "meta": {
                    //         "keepAlive": "true",
                    //         "title": "在售房源"
                    //     },
                    //     "name": "在售房源",
                    //     'hidden':'0'
                    // },
                    //租赁房源
                   
                   
                    
                        //房源签约审核
                    {
                        "path": "Signin",
                        "component": "PlatformAudit/SigningHome",
                        
                        "meta": {
                            "keepAlive": "true",
                            "title": "申请锁定房源审核",
                            "componentName":'',
                        },
                        "name": "",
                        "id": "190c2b43bec6a5f7a4194a85db67d96a",
                        'redirect':'/Signin/Index',
                        'hasChildrenShow':'0',
                        "children":[

                            {
                                "path": "Signin/Index",
                                "component": "PlatformAudit/Signing",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "申请锁定房源审核"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                            {
                                "path": "Signin/car",
                                "component": "PlatformAudit/Signingdel",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "房源签约审核  / S201906120002"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                          
                        ]
                    },
                    //交易中的房源
                    {
                        "path": "easy",
                        "component": "yjAgent/easyHome",
                        
                        "meta": {
                            "keepAlive": "true",
                            "title": "交易中的房源",
                            "componentName":'',
                        },
                        "name": "",
                        "id": "190c2b43bec6a5f7a4194a85db67d96a",
                        'redirect':'/easy/list',
                        'hasChildrenShow':'0',
                        "children":[
                            {
                                "path": "easy/list",
                                "component": "yjAgent/easyList",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": " 交易中的房源"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                           
                            
                            {
                                "path": "easy/ate",
                                "component": "yjAgent/easygenerate",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "交易中的房源 / 生成居间服务合同"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                            {
                                "path": "easy/atetext",
                                "component": "yjAgent/easygeneratetext",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "交易中的房源 / 生成居间服务合同"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },

                            {
                                "path": "easy/atethui",
                                "component": "yjAgent/easygeneratehui",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "交易中的房源 / 生成居间服务合同"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },

                            {
                                "path": "easy/Ver",
                                "component": "yjAgent/easyVerifytruth",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "交易中的房源 / S201906260008"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                            {
                                "path": "easy/Veradd",
                                "component": "yjAgent/easyVerifytruthadd",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "交易中的房源 / S201906260008"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                            {
                                "path": "easy/taxes",
                                "component": "yjAgent/easyPaytaxes",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "交易中的房源 / 308796546"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            }
                            
                           
                        ]
                    },
                    //我的房源
                    {
                        "path": "Mh",
                        "component": "yjAgent/M-house-Home",
                        
                        "meta": {
                            "keepAlive": "true",
                            "title": "我的房源",
                            "componentName":'',
                        },
                        "name": "",
                        "id": "190c2b43bec6a5f7a4194a85db67d96a",
                        'redirect':'/Mh/Index',
                        'hasChildrenShow':'0',
                        "children":[
                            {
                                "path": "Mh/Index",
                                "component": "yjAgent/M-house-Index",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "我的房源"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                            {
                                "path": "Mh/list",
                                "component": "yjAgent/M-house-List",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "我的房源 / 新增在售房源"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                            {
                                "path": "Mh/del",
                                "component": "yjAgent/M-house-details",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "我的房源 / 外滩首府11栋1单元601"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                        ]
                    },

                     //个人资料
                     {
                        "path": "per",
                        "component": "yjAgent/per-dataHome",
                        
                        "meta": {
                            "keepAlive": "true",
                            "title": "个人资料",
                            "componentName":'',
                        },
                        "name": "",
                        "id": "190c2b43bec6a5f7a4194a85db67d96a",
                        'redirect':'/per/Index',
                        'hasChildrenShow':'0',
                        "children":[
                            {
                                "path": "per/Index",
                                "component": "yjAgent/per-dataList",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "个人资料"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                            {
                                "path": "per/car",
                                "component": "yjAgent/per-datadetails",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "个人资料\编辑"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                        ]
                    },


                     //悦居门店店长
                     {
                        "path": "long",
                        "component": "Shopowner/long-Home",
                        
                        "meta": {
                            "keepAlive": "true",
                            "title": "房源发布审核",
                            "componentName":'',
                        },
                        "name": "",
                        "id": "190c2b43bec6a5f7a4194a85db67d96a",
                        'redirect':'/long/Index',
                        'hasChildrenShow':'0',
                        "children":[
                            {
                                "path": "long/Index",
                                "component": "Shopowner/long-List",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "房源发布审核"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                            {
                                "path": "long/car",
                                "component": "Shopowner/long-details",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "房源发布审核 / 外滩首府11栋1单元601 - 张晓霞"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                        ]
                    },
                    //用户管理
                    {
                        "path": "user",
                        "component": "Shopowner/user-Home",
                        
                        "meta": {
                            "keepAlive": "true",
                            "title": "用户管理",
                            "componentName":'',
                        },
                        "name": "",
                        "id": "190c2b43bec6a5f7a4194a85db67d96a",
                        'redirect':'/user/admin',
                        'hasChildrenShow':'0',
                        "children":[
                            {
                                "path": "user/admin",
                                "component": "Shopowner/user-admin",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "用户管理"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                            {
                                "path": "user/Index",
                                "component": "Shopowner/user-list",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "新建帐号"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                            {
                                "path": "user/car",
                                "component": "Shopowner/user-msg",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "用户详情"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                        ]
                    },
                     //悦居管理员
                     {
                        "path": "Y-A",
                        "component": "Y-Administrators/Admin-Home",
                        
                        "meta": {
                            "keepAlive": "true",
                            "title": "帐号管理",
                            "componentName":'',
                        },
                        "name": "",
                        "id": "190c2b43bec6a5f7a4194a85db67d96a",
                        'redirect':'/Y-A/admin',
                        'hasChildrenShow':'0',
                        "children":[

                            {
                                "path": "Y-A/admin",
                                "component": "Y-Administrators/Admin-Index",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "帐号管理"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                            {
                                "path": "Y-A/Index",
                                "component": "Y-Administrators/Admin-New",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "帐号管理 / 新建帐号"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                            {
                                "path": "Y-A/car",
                                "component": "Y-Administrators/Admin-Agent",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "帐号管理 / 韩银萍"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                            {
                                "path": "Y-A/del",
                                "component": "Y-Administrators/Admin-Shopowner",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "帐号管理 / 韩银萍"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                        ]
                    },

                     //门店管理
                     {
                        "path": "store",
                        "component": "Y-Administrators/storeHome",
                        
                        "meta": {
                            "keepAlive": "true",
                            "title": "门店管理",
                            "componentName":'',
                        },
                        "name": "",
                        "id": "190c2b43bec6a5f7a4194a85db67d96a",
                        'redirect':'/store/Index',
                        'hasChildrenShow':'0',
                        "children":[

                            {
                                "path": "store/Index",
                                "component": "Y-Administrators/store",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "门店管理"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                            {
                                "path": "store/car",
                                "component": "Y-Administrators/Newstore",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "门店管理 / 新建门店"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                            
                        ]
                    },
                        //实勘任务退回审核
                   {
                            "path": "Audit",
                            "component": "PlatformAudit/Audit",
                            "meta": {
                                "keepAlive": "true",
                                "title": "实勘任务退回审核"
                            },
                            "name": "实勘任务退回审核",
                            'hidden':'0'
                    },
                 
                //资金监管窗口

                {
                    "path": "halls",
                    "component": "hall/SquareHome",
                    
                    "meta": {
                        "keepAlive": "true",
                        "title": "资金监管协议书",
                        "componentName":'',
                    },
                    "name": "",
                    "id": "190c2b43bec6a5f7a4194a85db67d96a",
                    'redirect':'/halls/Index',
                    'hasChildrenShow':'0',
                    "children":[
                        {
                            "path": "halls/Index",
                            "component": "hall/SquareIndex",
                            
                            "meta": {
                                "keepAlive": "true",
                                "title": "资金监管协议书"
                            },
                            "name": "system-roleUserList",
                            "id": "190c2b43bec6a5f7a4194a85db67d96a",
                            'hidden':'0'
                        },
                        {
                            "path": "halls/La",
                            "component": "hall/Launch",
                            
                            "meta": {
                                "keepAlive": "true",
                                "title": "资金监管协议书"
                            },
                            "name": "system-roleUserList",
                            "id": "190c2b43bec6a5f7a4194a85db67d96a",
                            'hidden':'0'
                        },

                        {
                            "path": "halls/Unpaid",
                            "component": "hall/Unpaid",
                            "meta": {
                                "keepAlive": "true",
                                "title": "资金监管协议书"
                            },
                            "name": "system-roleUserList",
                            "id": "190c2b43bec6a5f7a4194a85db67d96a",
                            'hidden':'0'
                        },
                        
                      
                    ]
                },

                //网签窗口
                
                {
                    "path": "Net",
                    "component": "Netsign/NetsignHome",
                    
                    "meta": {
                        "keepAlive": "true",
                        "title": "网签入口",
                        "componentName":'',
                    },
                    "name": "",
                    "id": "190c2b43bec6a5f7a4194a85db67d96a",
                    'redirect':'/Net/Index',
                    'hasChildrenShow':'0',
                    "children":[
                        {
                            "path": "Net/Index",
                            "component": "Netsign/NetsignList",
                            
                            "meta": {
                                "keepAlive": "true",
                                "title": "网签录入"
                            },
                            "name": "system-roleUserList",
                            "id": "190c2b43bec6a5f7a4194a85db67d96a",
                            'hidden':'0'
                        },
                        {
                            "path": "Net/car",
                            "component": "Netsign/Netsigndel",
                            
                            "meta": {
                                "keepAlive": "true",
                                "title": "房产验真 / S201906230001"
                            },
                            "name": "system-roleUserList",
                            "id": "190c2b43bec6a5f7a4194a85db67d96a",
                            'hidden':'0'
                        },
                       
                        
                      
                    ]
                },

                   //客源管理
                
                   {
                    "path": "Tour",
                    "component": "yjAgent/TourIndex",
                    
                    "meta": {
                        "keepAlive": "true",
                        "title": "客源管理",
                        "componentName":'',
                    },
                    "name": "",
                    "id": "190c2b43bec6a5f7a4194a85db67d96a",
                    'redirect':'/Tour/Index',
                    'hasChildrenShow':'0',
                    "children":[
                        {
                            "path": "Tour/Index",
                            "component": "yjAgent/Touristsource",
                            
                            "meta": {
                                "keepAlive": "true",
                                "title": "客源管理列表"
                            },
                            "name": "system-roleUserList",
                            "id": "190c2b43bec6a5f7a4194a85db67d96a",
                            'hidden':'0'
                        },
                        {
                            "path": "Tour/creat",
                            "component": "yjAgent/Tourdetails",
                            
                            "meta": {
                                "keepAlive": "true",
                                "title": "客源管理详情"
                            },
                            "name": "system-roleUserList",
                            "id": "190c2b43bec6a5f7a4194a85db67d96a",
                            'hidden':'0'
                        },
                        
                    ]
                },
                //我的实勘任务

                {
                    "path": "MyHome",
                    "component": "yjAgent/MyreaHome",
                    
                    "meta": {
                        "keepAlive": "true",
                        "title": "我的实勘任务",
                        "componentName":'',
                    },
                    "name": "",
                    "id": "190c2b43bec6a5f7a4194a85db67d96a",
                    'redirect':'/MyHome/Index',
                    'hasChildrenShow':'0',
                    "children":[
                        {
                            "path": "MyHome/Index",
                            "component": "yjAgent/MyreaList",
                            
                            "meta": {
                                "keepAlive": "true",
                                "title": "我的实勘任务列表"
                            },
                            "name": "system-roleUserList",
                            "id": "190c2b43bec6a5f7a4194a85db67d96a",
                            'hidden':'0'
                        },
                        {
                            "path": "MyHome/creat",
                            "component": "yjAgent/MyreaSell",
                            
                            "meta": {
                                "keepAlive": "true",
                                "title": "我的实勘任务 / 提交实勘资料"
                            },
                            "name": "system-roleUserList",
                            "id": "190c2b43bec6a5f7a4194a85db67d96a",
                            'hidden':'0'
                        },
                        {
                            "path": "MyHome/car",
                            "component": "yjAgent/Myrealease",
                            
                            "meta": {
                                "keepAlive": "true",
                                "title": "我的实勘任务 / 提交实勘资料"
                            },
                            "name": "system-roleUserList",
                            "id": "190c2b43bec6a5f7a4194a85db67d96a",
                            'hidden':'0'
                        },
                        
                    ]
                },

                //房产验真


                
                {
                    "path": "pro",
                    "component": "property/propertyHome",
                    
                    "meta": {
                        "keepAlive": "true",
                        "title": "房产验真",
                        "componentName":'',
                    },
                    "name": "",
                    "id": "190c2b43bec6a5f7a4194a85db67d96a",
                    'redirect':'/pro/Index',
                    'hasChildrenShow':'0',
                    "children":[
                        {
                            "path": "pro/Index",
                            "component": "property/propertyList",
                            
                            "meta": {
                                "keepAlive": "true",
                                "title": "房产验真"
                            },
                            "name": "system-roleUserList",
                            "id": "190c2b43bec6a5f7a4194a85db67d96a",
                            'hidden':'0'
                        },
                        {
                            "path": "pro/creat",
                            "component": "property/propertydel",
                            
                            "meta": {
                                "keepAlive": "true",
                                "title": "房产验真 / 123"
                            },
                            "name": "system-roleUserList",
                            "id": "190c2b43bec6a5f7a4194a85db67d96a",
                            'hidden':'0'
                        },
                       
                        
                    ]
                },
                
                    //修改密码
                    // {
                    //     "path": "Password",
                    //     "component": "yjAgent/Password",
                    //     "meta": {
                    //         "keepAlive": "true",
                    //         "title": "修改密码"
                    //     },
                    //     "name": "修改密码",
                    //     'hidden':'0'
                    // },

                    //在售房源

                    {
                        "path": "House",
                        "component": "yjAgent/salingIndex",
                        
                        "meta": {
                            "keepAlive": "true",
                            "title": "在售房源",
                            "componentName":'',
                        },
                        "name": "",
                        "id": "190c2b43bec6a5f7a4194a85db67d96a",
                        'redirect':'/House/Index',
                        'hasChildrenShow':'0',
                        "children":[
                            {
                                "path": "House/Index",
                                "component": "yjAgent/salinghouse",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "在售房源"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                            {
                                "path": "House/creat",
                                "component": "yjAgent/salingdet",
                                
                                "meta": {
                                    "keepAlive": "true",
                                    "title": "在售房源 / 001000001"
                                },
                                "name": "system-roleUserList",
                                "id": "190c2b43bec6a5f7a4194a85db67d96a",
                                'hidden':'0'
                            },
                        ]
                    },


                     

            
        ]
    },
    "timestamp": 1560136878006
}

